<template>
  <v-card
    ref="listRoot"
    class="ma-0 px-1 app-list-page"
    :class="{
      'app-list-page--fixed': !isMobile && !mobileShow,
    }"
    width="100%"
    style="height: auto"
    flat
  >
    <v-app-bar
      ref="listToolbar"
      flat
      class="my-0 app-list-toolbar"
      :class="!isMobile && !mobileShow ? 'px-2 mb-0 py-0' : 'mb-6 py-1 px-2'"
      dense
      :height="!isMobile && !mobileShow ? 40 : 30"
    >
      <v-toolbar-title
        class="app-list-toolbar__title"
        :class="!isMobile && !mobileShow ? 'me-4' : 'mt-4 me-4'"
        >{{ $t("main-group-list") }}</v-toolbar-title>
      <div v-if="!isMobile && !mobileShow" class="app-list-toolbar__search" style="width: 230px">
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          clearable
          :label="$t('search')"
          flat
          outlined
          dense
          hide-details
        />
      </div>
      <v-spacer />
      <v-btn
        v-if="selected.length > 0 && !isMobile && !mobileShow"
        outlined
        @click="deletDialog = true"
        class="mt-4 ms-2"
        color="pink"
        height="32"
      >
        <p class="font-weight-thin mb-0 me-2">
          {{ $t("remove") }}
        </p>
        <v-icon> mdi-trash-can-outline </v-icon>
      </v-btn>
      <v-btn
        v-if="!isMobile && !isTablet"
        outlined
        @click="getItems"
        class="mt-4 px-1 ms-2"
        color="grey darken-2"
        height="32"
        @shortkey="getItems"
        v-shortkey="['f5']"
        style="min-width: 35px !important; padding: 0 !important"
      >
        <v-icon> mdi-refresh </v-icon>
      </v-btn>
      <v-btn
        v-if="!isMobile && !mobileShow"
        outlined
        class="mt-4 ms-2"
        color="primary"
        height="32"
        @click="openDialog('add')"
      >
        <p class="font-weight-thin mb-0 me-2">
          {{ $t("new-main-group") }}
        </p>
        <v-icon> mdi-plus </v-icon>
      </v-btn>
    </v-app-bar>
    <v-row v-if="isMobile || isTablet" class="mx-0">
      <v-col class="mb-4 px-2" cols="12">
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          clearable
          :label="$t('search')"
          flat
          outlined
          dense
        />
      </v-col>
    </v-row>
    <v-col
      ref="listTableCol"
      cols="12"
      class="px-2 app-list-table-col"
      :class="{ 'mt-2': !isMobile && !isTablet, 'mt-0': isMobile || isTablet }"
    >
      <v-data-table
        v-if="headers"
        ref="listTable"
        v-model="selected"
        v-column-resize="mainGroupColumnPlugins"
        v-column-drag="mainGroupColumnPlugins"
        v-column-pin="mainGroupColumnPlugins"
        :height="isMobile || mobileShow ? 323 : tableHeight"
        fixed-header
        :headers="showHeaders"
        :items="items"
        :options.sync="options"
        :server-items-length="totalItems"
        :loading="loading"
        :page.sync="page"
        :hide-default-header="isMobile || mobileShow"
        multi-sort
        :show-select="showSelect"
        item-key="id"
        class="mb-2 td-hide-border app-list-table main-table invoice-sell-table-scroll"
        :class="{
          'mb-0 app-list-table--dense': !isMobile && !mobileShow,
        }"
        :style="
          !isMobile && !mobileShow
            ? 'border: 1px solid #e3e3e3; border-radius: 2px'
            : 'border: 1px solid #e3e3e3; border-radius: 6px'
        "
        :footer-props="{
          showFirstLastPage: !mobileShow ? true : false,
          itemsPerPageOptions: [10, 25, 50, 100, 500],
          firstIcon: 'mdi-arrow-collapse-left',
          lastIcon: 'mdi-arrow-collapse-right',
          prevIcon: 'mdi-plus',
          nextIcon: 'mdi-minus',
        }"
      >
        <template v-if="isMobile || mobileShow" v-slot:item="{ item, index }">
          <tr :class="{ 'mobile-show': mobileShow }">
            <td class="px-0">
              <v-list-item
                class="data-table-list-items mobile-td-list-border-primary"
                dense
              >
                <v-list-item-icon>
                  <div class="d-flex">
                    <p class="mt-1">
                      {{ +index + +1 }}
                    </p>
                    <v-menu offset-y>
                      <template v-slot:activator="{ attrs, on }">
                        <v-btn color="primary" v-bind="attrs" icon v-on="on">
                          <v-icon medium> mdi-dots-vertical </v-icon>
                        </v-btn>
                      </template>
                      <v-list dense>
                        <v-list-item link @click="openDialog('edit', item, index)">
                          <v-list-item-icon>
                            <v-icon class="mt-2"> mdi-clipboard-edit </v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('edit')" />
                        </v-list-item>
                        <v-list-item
                          v-show="removePermission(typeForm)"
                          link
                          @click="openDeleteDialog(item)"
                        >
                          <v-list-item-icon>
                            <v-icon color="pink"> mdi-trash-can-outline </v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('remove')" />
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </div>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="text-wrap">
                    {{ item.name }}({{ item.code }})
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </td>
          </tr>
        </template>
        <template v-slot:item.actions="{ item, index }">
          <v-menu offset-y>
            <template v-slot:activator="{ attrs, on }">
              <v-btn color="primary" v-bind="attrs" icon v-on="on">
                <v-icon medium> mdi-dots-vertical </v-icon>
              </v-btn>
            </template>
            <v-list dense>
              <v-list-item link @click="openDialog('edit', item, index)">
                <v-list-item-icon>
                  <v-icon class="mt-2"> mdi-clipboard-edit </v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('edit')" />
              </v-list-item>
              <v-list-item
                v-show="removePermission(typeForm)"
                link
                @click="openDeleteDialog(item)"
              >
                <v-list-item-icon>
                  <v-icon color="pink"> mdi-trash-can-outline </v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('remove')" />
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        <template v-slot:item.row="{ item }">
          <v-card-text class="pa-0 text-caption text-disable">
            {{ parseInt(items.indexOf(item)) + parseInt(from) }}
          </v-card-text>
        </template>
        <template v-slot:item.group="{ item, index }">
          <div class="d-flex align-center gap-1">
            <img
              :src="item.avatar?.link || require('@/assets/imagePlacholder.png')"
              style="width: 35px"
            />
            <v-card-text
              class="pa-0"
              :class="{ 'text-body-2': item.name, 'text-caption': item.name == null }"
              style="color: #0066ff; cursor: pointer"
              @click="openDialog('edit', item, index)"
            >
              {{
                item.name && item.name != null
                  ? item.name
                  : item.group && item.group != null
                  ? item.group
                  : $t("haveNot")
              }}
            </v-card-text>
          </div>
        </template>
        <template v-slot:item.category="{ item, index }">
          <v-card-text class="pa-0 text-body-2">
            {{ item.id != undefined ? resolveCategoryCount(item.id) : "-" }}
          </v-card-text>
        </template>
        <template v-slot:item.subCategory="{ item, index }">
          <v-card-text class="pa-0 text-body-2">
            {{ item.id != undefined ? resolveSubCategoryCount(item.id) : "-" }}
          </v-card-text>
        </template>
        <template v-slot:item.priority="{ item }">
          <v-card-text class="pa-0 text-body-2">
            {{ item.priority ?? item.Priority ?? "-" }}
          </v-card-text>
        </template>
        <template v-slot:item.productCount="{ item }">
          <v-card-text
            class="pa-0"
            :class="{ 'text-body-2': item.id, 'text-caption': item.id == null }"
          >
            {{ item.products_count != undefined ? item.products_count : $t("haveNot") }}
          </v-card-text>
        </template>
        <template v-slot:footer.prepend>
          <v-col
            v-show="!isMobile"
            cols="1"
            class="pa-0 app-list-goto-page"
            :class="{
              'app-list-goto-page--compact': !isMobile && !mobileShow,
            }"
            :style="
              !isMobile && !mobileShow ? null : 'margin-top: -10px'
            "
          >
            <!-- Flat glass: no border/shadow — bg via inline so footer CSS cannot override -->
            <div
              class="app-list-goto-page__box"
              :style="
                !isMobile && !mobileShow
                  ? {
                      height: '24px',
                      padding: '0 8px',
                      borderRadius: '4px',
                      backgroundColor: 'rgba(120, 130, 140, 0.12)',
                      border: 'none',
                      boxShadow: 'none',
                      backdropFilter: 'blur(10px)',
                      WebkitBackdropFilter: 'blur(10px)',
                    }
                  : null
              "
            >
              <span
                v-if="!isMobile && !mobileShow"
                class="app-list-goto-page__label"
                >{{ $t("goToPage") }}</span
              >
              <v-text-field
                v-model.number="page"
                :label="
                  !isMobile && !mobileShow ? undefined : $t('goToPage')
                "
                min="1"
                :max="pageCount"
                type="number"
                :outlined="isMobile || isTablet || mobileShow"
                :solo="!isMobile && !mobileShow"
                :flat="!isMobile && !mobileShow"
                :height="!isMobile && !mobileShow ? 20 : 32"
                hide-details
                hide-spin-buttons
                dense
                :suffix="' / ' + pageCount"
                class="app-list-goto-page__field"
              />
            </div>
          </v-col>
        </template>
      </v-data-table>
    </v-col>
    <v-row />

    <!--delete dialog items of list-->
    <v-dialog
      v-model="deletDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="400"
    >
      <v-card>
        <v-col>
          <v-btn icon class="close-hover" @click="deletDialog = false">
            <v-icon color="grey" large> mdi-close </v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <v-img class="mx-auto" width="200" src="@/assets/stop.svg" />
        </v-col>
        <v-col class="mt-3 pr-7">
          <p class="mx-auto font-weight-medium">
            {{ $t("are-you-sure-delete-this-case") }}
          </p>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn
                v-if="selected.length > 0"
                color="primary"
                :loading="loading"
                @click="removegroup"
              >
                {{ $t("remove") }}
              </v-btn>
              <v-btn v-if="selected.length == 0" color="primary" @click="removegroup">
                {{ $t("remove") }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left"
                @click="deletDialog = false"
              >
                {{ $t("cancel") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--dialog list (add + edit)-->
    <v-dialog
      v-model="gpDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="450"
    >
      <v-card class="pa-5">
        <v-form ref="form" v-model="valid">
          <div class="d-flex align-center justify-space-between mb-4">
            <v-card-text class="pa-0 text-body-1">
              {{ dialogType == "add" ? $t("new-main-group") : $t("edit-main-group") }}
            </v-card-text>
            <v-icon @click="gpDialog = false" style="cursor: pointer">mdi-close</v-icon>
          </div>
          <div class="group-dialog-body mb-6 mt-6">
            <div class="group-dialog-avatar">
              <file-picker
                ref="refFilePicker"
                v-model="imagePicker"
                :label="$t('uploadImage')"
                :avatar="true"
                :multiple="false"
                extensions="image/png, image/gif, image/jpeg"
                type-prop="categoryAvatar"
                :val="imagePickerVal ? imagePickerVal : null"
              />
            </div>
            <div class="wrapper-toggle-tax d-flex align-center">
              <div
                v-for="(item, statusIndex) in statusOption"
                :key="statusIndex"
                class="child flex-fill text-center"
                :style="{
                  'background-color': status == item.value ? '#0066ff' : '',
                  'border-color': status == item.value ? '#0066ff' : 'silver',
                  color: status == item.value ? '#fff' : '',
                }"
                @click="selectStatusOption(item)"
              >
                <v-card-text class="pa-0 text-body-2">{{ item.label }}</v-card-text>
              </div>
            </div>
            <div class="group-dialog-name-row d-flex align-center gap-2">
              <v-text-field
                v-model="group"
                :label="$t('main-group-title')"
                height="32"
                dense
                outlined
                clearable
                hide-details="auto"
                class="flex-fill mt-0 pt-0"
                :rules="[(v) => !!v || $t('is-required')]"
              />
              <v-text-field
                v-model.number="priority"
                :label="$t('priority')"
                type="number"
                height="32"
                dense
                outlined
                clearable
                hide-details
                class="group-dialog-priority mt-0 pt-0"
              />
            </div>
          </div>

          <div class="d-flex justify-end gap-2">
            <v-btn
              color="error"
              outlined
              :loading="loading"
              height="32"
              @click="gpDialog = false"
            >
              {{ $t("cancel") }}
            </v-btn>
            <v-btn
              color="primary"
              :loading="loading"
              height="32"
              @click="checkValidation"
              :disabled="!itemHasId"
            >
              {{ dialogType == "add" ? $t("confirm") : $t("edit") }}
            </v-btn>
          </div>
        </v-form>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snakbar"
      :color="snakbarColor ? snakbarColor : 'primary'"
      top
      style="z-index: 1000000000000 !important"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snakbar = !snakbar">
          {{ $t("close") }}
        </v-btn>
      </template>
    </v-snackbar>
    <Confirm ref="confirm" />
  </v-card>
</template>

<script>
import { required } from "vee-validate/dist/rules";
import General from "../../../../Mixins/general";
import filePicker from "../../components/general/filePicker/index";
import {
  applyColumnSettings,
  loadColumnSettings,
} from "@/plugins/columnSettings/columnSettings";
import { reorderPinnedHeaders } from "@/plugins/columnPin/columnPin";

export default {
  name: "category",
  components: {
    autocomplete: () => import("../../components/general/patial/autocomplete"),
    aicomplete: () => import("../../components/general/AIcomplete/index"),
    filePicker,
  },
  mixins: [General],
  props: ["input", "type", "refId", "mobileShow", "titleProp"],
  data: () => ({
    selected: [],
    pageCount: 1,
    page: 1,
    selectedHeaders: [],
    deletDialog: false,
    showSelect: true,
    model: null,
    from: 1,
    temp: null,
    deleteItem: null,
    items: [],
    subCategoryList: [],
    categoryList: [],
    sortBy: [],
    dialog: null,
    timer: 0,
    totalItems: 0,
    snakbar: false,
    typeForm: null,
    snakbarText: null,
    loading: true,
    options: {
      itemsPerPage: 5,
    },
    headers: null,
    listViewportObserver: null,
    listViewportRaf: null,
    search: null,
    gpDialog: false,
    dialogType: null,
    valid: true,
    editedIndex: null,
    editedItem: null,
    newItem: {},
    group: null,
    itemHasId: true,
    attachedImg: null,
    selectedImageFile: null,
    imagePicker: null,
    imagePickerVal: null,
    status: "active",
    priority: null,
  }),
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.name === "xs";
    },
    isDesktopListViewport() {
      return !this.isMobile && !this.mobileShow;
    },
    mainGroupColumnPersistKey() {
      return "group-main-list-columns-" + (this.$route.name || "mainGroup");
    },
    mainGroupLockedColumns() {
      // Fixed sticky block: select + actions + row (no id column in this list)
      var locked = ["actions", "row"];
      return this.showSelect ? ["__select"].concat(locked) : locked;
    },
    mainGroupColumnPlugins() {
      // show-select inserts a leading checkbox <th>; pad visibleHeaders so
      // pin/resize/drag index mapping stays aligned with thead cells.
      var selectHeader = {
        value: "__select",
        text: "",
        width: 32,
        sortable: false,
        pinned: false,
        originalIndex: -1,
      };
      var visible = this.showSelect
        ? [selectHeader].concat(this.showHeaders || [])
        : this.showHeaders || [];
      return {
        headers: this.headers,
        visibleHeaders: visible,
        locked: this.mainGroupLockedColumns,
        anchor: "group",
        minWidth: 60,
        persistKey: this.mainGroupColumnPersistKey,
      };
    },
    showHeaders() {
      var app = this;
      return this.headers.filter(function (s) {
        return app.selectedHeaders.includes(s);
      });
    },
    statusOption() {
      return [
        { label: this.$t("active"), value: "active" },
        { label: this.$t("deactive"), value: "deactive" },
      ];
    },
  },
  watch: {
    refId(val, oldVal) {
      // this.items = []
      this.getItems();
    },
    model() {
      this.$emit("input", this.model);
    },
    selected() {
      this.$emit("input", this.selected.text);
      if (this.selected.length > 0) {
        this.model = this.selected[0].text;
        this.temp = this.selected[0].text;
      }
      this.dialog = false;
    },
    search() {
      var app = this;
      app.loading = true;
      app.page = 1;
      clearTimeout(this.timer);
      this.timer = setTimeout(function () {
        app.getItems();
      }, 1000);
    },
    options: {
      handler() {
        var app = this;
        app.sortBy = [];
        app.options.sortBy.map(function (value, key) {
          const index = app.headers.findIndex((h) => h.value === value);
          app.sortBy.push(app.headers[index].table);
        });
        this.getItems();
      },
      deep: true,
      immediate: false,
    },
    sortBy() {
      const index = this.headers.findIndex((h) => h.value === this.sortBy);
      if (index > -1) {
        this.sortBy = this.headers[index].table;
      }
    },
    loading(val) {
      if (!val && this.isDesktopListViewport) {
        this.$nextTick(() => {
          this.bindListViewportObserver();
          this.scheduleDesktopTableHeightUpdate();
        });
      }
    },
    isDesktopListViewport(val) {
      if (val) {
        this.$nextTick(() => {
          this.updateDesktopTableHeight();
          this.bindListViewportObserver();
        });
      } else {
        this.unbindListViewportObserver();
        this.tableHeight = window.innerHeight - 245;
      }
    },
  },
  beforeMount() {
    if (this.$route.name === "mainGroup") {
      this.typeForm = "group";
    }
    this.headers = [
      {
        text: this.$t("operation"),
        align: "start",
        sortable: false,
        value: "actions",
        width: 20,
      },
      {
        text: this.$t("#"),
        align: "start",
        sortable: false,
        value: "row",
        width: 20,
      },
      {
        text: this.$t("main-group-title"),
        sortable: false,
        value: "group",
      },
      {
        text: this.$t("priority"),
        sortable: false,
        value: "priority",
      },
      {
        text: this.$t("sub-group-count"),
        sortable: false,
        value: "category",
      },
      {
        text: this.$t("sub-category-count"),
        sortable: false,
        value: "subCategory",
      },
      {
        text: this.$t("countProductInvoice"),
        sortable: false,
        value: "productCount",
      },
    ];
    if (this.input) {
      this.model = this.input;
    }
    this.headersMap = this.headers;
    this.selectedHeaders = this.headers;
    reorderPinnedHeaders(this.headers, {
      locked: this.mainGroupLockedColumns,
      anchor: "group",
    });
    this.loadMainGroupColumnSettings();
  },
  methods: {
    resolveRefEl(ref) {
      if (!ref) return null;
      return ref.$el || ref;
    },
    onResize() {
      if (this.isDesktopListViewport) {
        this.updateDesktopTableHeight();
        return;
      }
      this.tableHeight = window.innerHeight - 245;
    },
    scheduleDesktopTableHeightUpdate() {
      if (this.listViewportRaf) cancelAnimationFrame(this.listViewportRaf);
      this.listViewportRaf = requestAnimationFrame(() => {
        this.listViewportRaf = null;
        this.updateDesktopTableHeight();
      });
    },
    updateDesktopTableHeight() {
      if (!this.isDesktopListViewport) {
        this.tableHeight = window.innerHeight - 245;
        return;
      }
      const rootEl = this.resolveRefEl(this.$refs.listRoot);
      const toolbarEl = this.resolveRefEl(this.$refs.listToolbar);
      const summaryEl = this.resolveRefEl(this.$refs.listSummary);
      const tableColEl = this.resolveRefEl(this.$refs.listTableCol);
      const tableEl = this.resolveRefEl(this.$refs.listTable);
      if (!rootEl || !tableColEl) {
        this.tableHeight = window.innerHeight - 245;
        return;
      }
      const rootStyle = window.getComputedStyle(rootEl);
      const rootPadding =
        (parseFloat(rootStyle.paddingTop) || 0) +
        (parseFloat(rootStyle.paddingBottom) || 0);
      const toolbarHeight = toolbarEl ? toolbarEl.offsetHeight : 0;
      let summaryHeight = 0;
      if (summaryEl) {
        const summaryVisible =
          summaryEl.offsetParent !== null ||
          summaryEl.getClientRects().length > 0;
        if (summaryVisible) {
          const summaryStyle = window.getComputedStyle(summaryEl);
          summaryHeight =
            summaryEl.offsetHeight +
            (parseFloat(summaryStyle.marginTop) || 0) +
            (parseFloat(summaryStyle.marginBottom) || 0);
        }
      }
      const colStyle = window.getComputedStyle(tableColEl);
      const colPadding =
        (parseFloat(colStyle.paddingTop) || 0) +
        (parseFloat(colStyle.paddingBottom) || 0);
      const footerEl = tableEl
        ? tableEl.querySelector(".v-data-footer")
        : null;
      const footerHeight = footerEl ? footerEl.offsetHeight : 0;
      const tableStyle = tableEl ? window.getComputedStyle(tableEl) : null;
      const tableMargins = tableStyle
        ? (parseFloat(tableStyle.marginTop) || 0) +
          (parseFloat(tableStyle.marginBottom) || 0)
        : 0;
      const available =
        rootEl.clientHeight -
        rootPadding -
        toolbarHeight -
        summaryHeight -
        colPadding -
        footerHeight -
        tableMargins -
        3;
      this.tableHeight = Math.max(180, Math.floor(available));
    },
    bindListViewportObserver() {
      if (typeof ResizeObserver === "undefined") return;
      this.unbindListViewportObserver();
      const rootEl = this.resolveRefEl(this.$refs.listRoot);
      const summaryEl = this.resolveRefEl(this.$refs.listSummary);
      const tableColEl = this.resolveRefEl(this.$refs.listTableCol);
      const tableEl = this.resolveRefEl(this.$refs.listTable);
      const footerEl = tableEl ? tableEl.querySelector(".v-data-footer") : null;
      if (!rootEl && !summaryEl && !tableColEl) return;
      this.listViewportObserver = new ResizeObserver(() => {
        this.scheduleDesktopTableHeightUpdate();
      });
      if (rootEl) this.listViewportObserver.observe(rootEl);
      if (summaryEl) this.listViewportObserver.observe(summaryEl);
      if (tableColEl) this.listViewportObserver.observe(tableColEl);
      if (footerEl) this.listViewportObserver.observe(footerEl);
    },
    unbindListViewportObserver() {
      if (this.listViewportObserver) {
        this.listViewportObserver.disconnect();
        this.listViewportObserver = null;
      }
    },
    loadMainGroupColumnSettings() {
      var app = this;
      if (!app.headers || !app.headers.length) return;
      loadColumnSettings(app, app.mainGroupColumnPersistKey).then(function (snapshot) {
        if (!snapshot || !snapshot.length) return;
        applyColumnSettings(app.headers, snapshot, {
          locked: app.mainGroupLockedColumns,
          anchor: "group",
        });
        app.$forceUpdate();
      });
    },
    ImgSelected(e) {
      const file = e.target.files[0];
      if (!file) return;

      this.selectedImageFile = file;
      this.attachedImg = URL.createObjectURL(file);
    },
    getItems() {
      var app = this;
      app.loading = true;
      app.$axios
        .get(this.$endpoint + "productcategory", {
          params: {
            type: "group",
            page: app.options.page,
            itemPerPage: 10,
            parents: null,
            filter: null,
            search: this.search,
          },
        })
        .then((res) => {
          res = res.data;
          app.items = res.data;
          app.totalItems = res.total;
          app.pageCount = res.last_page;
          app.from = res.from;
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    getCategoryList() {
      var app = this;
      app.loading = true;
      app.$axios
        .get(this.$endpoint + "productcategory", {
          params: {
            type: "category",
            page: 1,
            itemPerPage: 10000,
            parents: null,
            filter: null,
            search: null,
          },
        })
        .then((res) => {
          res = res.data;
          app.categoryList = res.data;
        });
    },
    getSubCategoryList() {
      var app = this;
      app.loading = true;
      app.$axios
        .get(this.$endpoint + "productcategory", {
          params: {
            type: "subCategory",
            page: 1,
            itemPerPage: 10000,
            parents: null,
            filter: null,
            search: null,
          },
        })
        .then((res) => {
          res = res.data;
          app.subCategoryList = res.data;
        });
    },
    resolveCategoryCount(groupId) {
      if (this.categoryList.length > 0) {
        const category = this.categoryList.filter((item) => item.parent_id == groupId);
        return category.length;
      }
    },
    resolveSubCategoryCount(groupId) {
      if (this.categoryList.length > 0) {
        const category = this.categoryList.filter((item) => item.parent_id == groupId);
        if (category != undefined && category.length != 0) {
          const categoryId = category.map((item) => item.id);
          for (var i = 0; i < categoryId.length; ) {
            const subCategory = this.subCategoryList.filter(
              (item) => item.parent_id == categoryId[i]
            );
            subCategory.length++;
            return subCategory.length - 1;
          }
        } else {
          return 0;
        }
      }
    },
    openDialog(type, item, index) {
      this.dialogType = type;
      this.gpDialog = true;
      if (this.dialogType == "add") {
        this.itemHasId = true;
        this.clearModal();
      }
      if (this.dialogType == "edit" && item != undefined && index != undefined) {
        if (item.id != undefined) {
          this.group = item.name;
          this.imagePicker = item.avatar;
          this.imagePickerVal = item.avatar;
          this.status = item.status || "active";
          this.priority = item.priority ?? item.priority ?? null;
          this.itemHasId = true;
        } else {
          this.group = item.group;
          this.status = item.status || "active";
          this.priority = item.priority ?? item.priority ?? null;
          this.itemHasId = false;
        }
        this.editedIndex = index;
        this.editedItem = item;
      }
    },
    clearModal() {
      this.group = null;
      this.imagePicker = null;
      this.imagePickerVal = null;

      if (this.$refs.form) {
        this.$refs.form.reset();
      }

      this.status = "active";
      this.priority = null;
    },
    selectStatusOption(item) {
      this.status = item.value;
    },
    checkValidation() {
      if (this.dialogType == "add" && this.$refs.form.validate()) {
        this.add();
      }
      if (this.dialogType == "edit" && this.$refs.form.validate()) {
        this.edit();
      }
    },
    add() {
      this.newItem.group = this.group;
      this.newItem.image = this.imagePicker;
      this.newItem.status = this.status;
      this.newItem.priority = this.priority;

      var app = this;
      app.loading = true;

      app.$axios
        .post(app.$endpoint + "productcategory", {
          name: app.newItem.group,
          type: "group",
          parent: 0,
          image: app.newItem.image,
          status: app.status,
          priority: app.priority,
        })
        .then((res) => {
          res = res.data;
          const saved = res.data || {};
          if (app.newItem.image) {
            app.$refs.refFilePicker.create(saved.id);
          }
          app.items.push({
            ...saved,
            name: saved.name || app.newItem.group,
            status: saved.status || app.status,
            priority: saved.priority ?? app.priority,
          });
          app.gpDialog = false;
          app.$refs.refFilePicker.remove(null, 0);
        })
        .catch((err) => {
          app.serverErrorHandeler(err);
        })
        .finally(() => {
          app.loading = false;
        });
    },
    edit() {
      this.newItem.group = this.group;
      this.newItem.image = this.imagePicker;
      this.newItem.status = this.status;
      this.newItem.priority = this.priority;

      var app = this;
      app.loading = true;
      var id = app.editedItem.id;
      app.$axios
        .put(`${app.$endpoint}productcategory/${id}`, {
          name: app.newItem.group,
          type: "group",
          parent: 0,
          image: app.newItem.image,
          status: app.status,
          priority: app.priority,
        })
        .then((res) => {
          res = res.data;
          const saved = res.data || {};
          if (app.newItem.image) {
            app.$refs.refFilePicker.create(saved.id);
          }
          app.items.splice(app.editedIndex, 1, {
            ...app.editedItem,
            ...saved,
            name: saved.name || app.newItem.group,
            status: saved.status || app.status,
            priority: saved.priority ?? app.priority,
          });
          app.gpDialog = false;
          app.$refs.refFilePicker.remove(null, 0);
        })
        .catch((err) => {
          app.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    openDeleteDialog(item) {
      this.deleteItem = item;
      this.deletDialog = true;
    },
    removegroup() {
      var app = this;
      app.loading = true;

      if (this.selected.length > 0) {
        var selected = [];
        this.selected.map(function (value) {
          selected.push(value.id);
        });

        const ids = selected.join(",");

        app.$axios
          .delete(`${this.$endpoint}productcategory/${ids}`)
          .then((res) => {
            this.getItems();
            app.deletDialog = false;
            app.deleteItem = null;
            app.selected = [];
          })
          .catch((err) => {
            this.deletDialog = false;
            this.serverErrorHandeler(err);
          })
          .finally(function () {
            app.deleteItem = null;
            app.selected = [];
            app.loading = false;
          });
      } else {
        app.$axios
          .delete(this.$endpoint + "productcategory/" + this.deleteItem.id)
          .then((res) => {
            this.getItems();
            app.deletDialog = false;
            app.deleteItem = null;
            app.selected = [];
          })
          .catch((err) => {
            this.deletDialog = false;
            this.serverErrorHandeler(err);
          })
          .finally(function () {
            app.deleteItem = null;
            app.selected = [];
            app.loading = false;
          });
      }
    },
  },
  mounted() {
    this.getCategoryList();
    this.getSubCategoryList();
    if (this.isDesktopListViewport) {
      this.$nextTick(() => {
        this.bindListViewportObserver();
        this.updateDesktopTableHeight();
        this.$nextTick(() => {
          this.bindListViewportObserver();
          this.scheduleDesktopTableHeightUpdate();
        });
      });
    }
  },
  activated() {
    if (this.isDesktopListViewport) {
      this.$nextTick(() => {
        this.bindListViewportObserver();
        this.scheduleDesktopTableHeightUpdate();
      });
    }
  },
  deactivated() {
    this.unbindListViewportObserver();
  },
  beforeDestroy() {
    this.unbindListViewportObserver();
    if (this.listViewportRaf) {
      cancelAnimationFrame(this.listViewportRaf);
      this.listViewportRaf = null;
    }
  },
};
</script>

<style scoped>
::v-deep .ma-0.mt-0.pt-0.v-card.v-card--flat.v-sheet.theme--light {
  width: auto !important;
}
::v-deep .v-avatar.rounded {
  width: 80px !important;
  min-width: 80px !important;
  max-width: 80px !important;
}
::v-deep
  .v-text-field--outlined.v-input--dense.v-text-field--outlined
  > .v-input__control
  > .v-input__slot {
  min-height: 32px !important;
}
::v-deep .v-input--selection-controls__input {
  margin-left: 0;
  width: auto;
}
::v-deep .v-input--selection-controls__ripple {
  width: auto;
  height: auto;
  margin: 0;
}
::v-deep .v-btn--icon.v-size--default {
  height: auto;
  width: auto;
}
::v-deep .v-data-table table thead tr th,
::v-deep .v-data-table table tbody tr td {
  white-space: nowrap;
}
::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:nth-child(odd),
::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:nth-child(even) {
  /* background-color: transparent !important; */
  height: 60px;
}
.v-card__text {
  width: auto;
}
.wrapper-toggle-tax {
  border: 1px solid #d0d0d0;
  border-radius: 4px;
  width: 100%;
  height: 32px;
  overflow: hidden;
}
.wrapper-toggle-tax .child {
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.wrapper-toggle-tax .child:first-child {
  border-left: 1px solid #d0d0d0;
}
.wrapper-toggle-tax .v-card__text {
  width: 100%;
}
.group-dialog-body {
  display: grid;
  grid-template-columns: 96px 1fr;
  grid-template-rows: 32px 1fr;
  gap: 12px;
  align-items: start;
}
.group-dialog-avatar {
  grid-column: 1;
  grid-row: 1 / 3;
  width: 96px;
  height: 96px;
  max-width: 96px;
  overflow: visible;
}
.group-dialog-avatar ::v-deep .v-card {
  width: 96px !important;
  max-width: 96px !important;
  height: 96px !important;
}
.group-dialog-avatar ::v-deep .v-avatar,
.group-dialog-avatar ::v-deep .v-image,
.group-dialog-avatar ::v-deep img {
  width: 96px !important;
  min-width: 96px !important;
  max-width: 96px !important;
  height: 96px !important;
  max-height: 96px !important;
  aspect-ratio: 1 / 1 !important;
}
.group-dialog-avatar ::v-deep .v-btn {
  top: 0 !important;
}
.group-dialog-body .wrapper-toggle-tax {
  grid-column: 2;
  grid-row: 1;
}
.group-dialog-name-row {
  grid-column: 2;
  grid-row: 2;
  min-width: 0;
  align-self: center;
  margin-top: 8px;
}
.group-dialog-priority {
  flex: 0 0 88px;
  max-width: 88px;
}
.v-data-table >>> .v-data-table__wrapper::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.v-data-table >>> .v-data-table__wrapper::-webkit-scrollbar-thumb {
  background-color: silver;
}

.v-data-table >>> .v-data-table__wrapper::-webkit-scrollbar-track {
  background-color: #f1f1f1;
}
@media (max-width: 863px) {
  ::v-deep .v-data-table table tbody tr,
  ::v-deep
    .theme--light.v-data-table
    > .v-data-table__wrapper
    > table
    > tbody
    > tr:nth-child(odd),
  ::v-deep
    .theme--light.v-data-table
    > .v-data-table__wrapper
    > table
    > tbody
    > tr:nth-child(even) {
    height: auto;
  }
}
</style>
